// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4582":"css/admin-app.6702","6125":"css/app.6702"}[chunkId] + ".css";
};